import { c as _c } from "react/compiler-runtime";
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { useNotifications } from '../hooks/use-notifications';
import { useNotificationsActions } from '../hooks/use-notification-actions';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import NotificationEmptyList from './notification-empty-list';
import { NotificationItem } from './notification-item';
import NotificationsListSkeleton from './notifications-list-skeleton';
import { DoubleCheckmarkIcon, SettingsIcon, ThinArrowRightIcon } from '@systemeio/ui/icons';
import { twMerge } from 'tailwind-merge';
const defaultFilter = {
  onlyUnRead: false
};
export const NotificationsMenuContent = t0 => {
  const $ = _c(39);
  const {
    className
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    pagination
  } = usePagination(true);
  let t1;
  if ($[0] !== pagination) {
    t1 = {
      limit: 3,
      pagination,
      filter: defaultFilter
    };
    $[0] = pagination;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    notifications
  } = useNotifications(t1);
  const {
    markAllNotificationsAsRead
  } = useNotificationsActions();
  let t2;
  if ($[2] !== className) {
    t2 = twMerge("bg-background-secondary flex w-full flex-col py-4 text-sm shadow-lg", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("dashboard.notifications.title");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <h4 className="text-text-primary text-[18px]">{t3}</h4>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DoubleCheckmarkIcon />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("dashboard.notifications.mark_all_read");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== markAllNotificationsAsRead || $[12] !== t6) {
    t7 = <div className="stroke-text-primary hover:stroke-brand-primary text-text-primary hover:text-brand-primary inline-flex flex-row items-baseline gap-1 transition">{t5}<span className="cursor-pointer" onClick={markAllNotificationsAsRead}>{t6}</span></div>;
    $[11] = markAllNotificationsAsRead;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t7) {
    t8 = <div className="flex flex-row justify-between px-6">{t4}{t7}</div>;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== notifications) {
    t9 = notifications === undefined ? <NotificationsListSkeleton /> : notifications.items.length > 0 ? notifications.items.map(_temp) : <NotificationEmptyList />;
    $[17] = notifications;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <SettingsIcon className="fill-text-primary group-hover:fill-brand-primary" width={18} height={18} />;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("dashboard.notifications.manage_notifications.title");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11) {
    t12 = <LinkWithoutPrefetch className="primary-link text-text-primary hover:text-brand-primary group inline-flex flex-row items-center gap-1" href="/profile/notification-settings">{t10}<h4>{t11}</h4></LinkWithoutPrefetch>;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t) {
    t13 = t("dashboard.notifications.view_all");
    $[24] = t;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13) {
    t14 = <h4 className="capitalize">{t13}</h4>;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ThinArrowRightIcon />;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t14) {
    t16 = <LinkWithoutPrefetch className="primary-link stroke-text-primary hover:stroke-brand-primary text-text-primary hover:text-brand-primary inline-flex flex-row items-center gap-3" href="/notifications">{t14}{t15}</LinkWithoutPrefetch>;
    $[29] = t14;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t12 || $[32] !== t16) {
    t17 = <div className="flex justify-between px-6 pt-4">{t12}{t16}</div>;
    $[31] = t12;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t17 || $[35] !== t2 || $[36] !== t8 || $[37] !== t9) {
    t18 = <div className={t2}>{t8}{t9}{t17}</div>;
    $[34] = t17;
    $[35] = t2;
    $[36] = t8;
    $[37] = t9;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  return t18;
};
function _temp(notification) {
  return <NotificationItem key={notification.id} notification={notification} />;
}